import { useFormMutation } from "@/hooks/useFormMutation";
import { fetcher, sendData } from "@/services/api/fetcher";
import { ApiResponse, DataObject, DataPaginate } from "@/types";
import { useQuery } from "@tanstack/react-query";
import { LetterConfigPayload } from "./validation";

const fetchTempelateLetter = async (
  params?: string
): Promise<ApiResponse<DataPaginate<TemplateLetterResponse>>> => {
  return await fetcher(`templating/letter-template?${params}`);
};

export const useGetTempelateLetter = (params?: string) => {
  return useQuery<ApiResponse<DataPaginate<TemplateLetterResponse>>, Error>({
    queryKey: ["useGetTempelateLetter", params],
    queryFn: async () => {
      const response = await fetchTempelateLetter(params);
      return response;
    },
  });
};

export const useGetTempelateLetterDetail = (letter_letter_id: number) => {
  return useQuery<ApiResponse<DataObject<TemplateLetterDetailResponse>>, Error>(
    {
      queryKey: ["useGetTempelateLetterDetail", letter_letter_id],
      queryFn: async () => {
        const response = await fetcher(
          `templating/letter-template/${letter_letter_id}`
        );
        return response;
      },
    }
  );
};

export const useGetTempelateLetterDetailByTypeId = (
  letter_type: number | string
) => {
  return useQuery<ApiResponse<DataObject<TemplateLetterDetailResponse>>, Error>(
    {
      queryKey: ["useGetTempelateLetterDetailByTypeId", letter_type],
      queryFn: async () => {
        const response = await fetcher(
          `templating/letter-template/${letter_type}/template`
        );
        return response;
      },
      enabled: !!letter_type,
    }
  );
};

export const useTempalteLetterMutation = (letter_template_id?: number) => {
  return useFormMutation<
    ApiResponse<DataObject<{ id: number }>>,
    Error,
    LetterConfigPayload
  >({
    mutationFn: async (payload: LetterConfigPayload) => {
      return await sendData(
        letter_template_id
          ? `templating/letter-template/${letter_template_id}`
          : "templating/letter-template",
        payload,
        letter_template_id ? "PUT" : "POST"
      );
    },
    successMessage: "Berhasil Menambahkan Isi Surat",
  });
};

/**
 *
 * @param letter_template_id
 * @returns
 * @description
 * jika belum ada link google doc
 */
export const useGenerateTempalteLetterMutation = (
  letter_template_id: number
) => {
  return useFormMutation<ApiResponse<DataObject<any>>, Error>({
    mutationFn: async () => {
      return await sendData(
        `templating/generate-template-id/${letter_template_id}`,
        {},
        "PATCH"
      );
    },
    successMessage: "Berhasil Menambahkan Isi Surat",
  });
};
